import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
let ViedocHeader = class ViedocHeader extends LitElement {
    render() {
        const classNames = classMap({
            header: true,
        });
        return html ` <header class=${classNames}>
      <div class="header__application"><slot name="application"></slot></div>
      <div class="header__content"><slot name="content"></slot></div>
      <div class="header__actions"><slot name="actions"></slot></div>
    </header>`;
    }
};
ViedocHeader.styles = [
    css `
      .header {
        font-family: var(--font-family-monument);
        box-sizing: border-box;
        display: grid;
        grid-template-areas: 'application content actions';
        grid-template-columns: 1fr 1fr 1fr;
        place-items: center;
        padding: 0 1.875rem;
        height: 4.125rem;
        color: var(--primary-text-color);
      }

      .header__application {
        grid-area: application;
        justify-self: start;
      }

      .header__content {
        grid-area: content;
      }

      .header__actions {
        grid-area: actions;
        display: flex;
        justify-self: end;
        align-items: center;
        gap: 0.938rem;
      }
    `,
];
ViedocHeader = __decorate([
    customElement('viedoc-header')
], ViedocHeader);
export { ViedocHeader };
